enum PromotedBrandAdType {
  CategoryPromotedProduct = 0,
  SearchPromotedProduct = 1,
  SearchPromotedBrandCategory = 2,
  PhotoGridPromotedBrandLogo = 3,
  PhotoGridPromotedBrandSpotlight = 4,
}

export default PromotedBrandAdType;
